import "rxjs/add/operator/catch";
import "rxjs/add/operator/do";
import "rxjs/add/operator/map";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SharedService } from '../pages/Services/shared.service';
import { CookieService } from "ngx-cookie-service";
import { secureStorage } from '../pages/Services/secure-storage';

@Injectable()
export class SpecialService {
  apiHost: any;
  basicApiHost: any;
  userName: any;
  password: any;
  constructor(
    private http: HttpClient,
    private sharedServices:SharedService, private cookieService: CookieService   ) {
      this.sharedServices.getConfig().subscribe(result=>{
        if(result){
        this.apiHost = result["apiHost"];
        this.basicApiHost = result["basicApiHost"];
        this.userName =  result["username"];
        this.password =  result["basicAuthPassword"];
        }
        })
    }

  
  refreshToken(model: any, apiEndPoint: string): Promise<any> {
    let headers = new HttpHeaders();
    // let accessToken = JSON.parse(localStorage.getItem("currentUser"));
    let encr = secureStorage.hash("currentUser");
    let accessToken = JSON.parse(secureStorage.decrypt(this.cookieService.get(encr)));
    console.log("sPECIALsERVICES : 00: accessToken = " + JSON.stringify(accessToken));
    //headers = headers.set("Authorization", "Basic " + btoa(this.userName + ":" + this.password));
    //headers = headers.set("authorization", accessToken.accessToken,);
    headers = headers.set("Authorization", "Bearer " + accessToken.refreshToken);
    headers = headers.set("Content-Type", "application/json");
    headers = headers.set("refreshToken", "Bearer " + accessToken.refreshToken);
    return this.http
      .put(
        this.basicApiHost + "/" + apiEndPoint,
        JSON.stringify(model),
        {
          headers: headers,
          observe: "response"
        }
      ).map(response => {
        if (response.status == 200) {
          return response.body;
        }
        return response;
      }).toPromise();
  }
  }